/* @flow */
import React from 'react';

import AffiliationStore from 'stores/AffiliationStore';
import CurrentUser from 'auth/CurrentUser';
import Dialog from 'components/Dialog.jsx';
import BoxBody from 'components/BoxBody.jsx';
import Tymk from 'user/components/Tymk.jsx';
import Leads from 'collections/Leads';

class TymkModal extends React.Component {
  static propTypes = {
    leads: React.PropTypes.instanceOf(Leads).isRequired,
    triggeredContext: React.PropTypes.string.isRequired,
    onRequestHide: React.PropTypes.func,
  };

  static childContextTypes = {
    eventScreenName: React.PropTypes.string,
    eventProperties: React.PropTypes.object,
  };

  getChildContext() {
    return {
      eventScreenName: 'invite_teacher_leads_screen',
      eventProperties: {
        total: this.props.leads.length,
        previous_screen_name: this.props.triggeredContext,
      },
    };
  }

  render() {
    const user = CurrentUser.getUser();
    return (
      <Dialog eventScreenName="TymkModal" {...this.props} size="small">
        <BoxBody>
          <Tymk
            {...this.props}
            afterSendInvitations={this.props.onRequestHide}
            organizations={AffiliationStore.getMemberOrganizations()}
            user={user}
          />
        </BoxBody>
      </Dialog>
    );
  }
}

export default TymkModal;



// WEBPACK FOOTER //
// ./src/user/components/TymkModal.jsx